import { CrudModel } from "../plugins/Cruxtify/CrudModel";

export class IppyDippyCrudModel extends CrudModel {}
